module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-accept-invite"
  }, [_c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.subTitle,
      "error": _vm.formError
    }
  }), (!_vm.expired) ? _c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [(_vm.showNameInputs) ? _c('div', [_c('div', {
    staticClass: "w-login-form__row"
  }, [_c('div', {
    staticClass: "w-input"
  }, [_c('label', {
    staticClass: "w-input__label",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("First Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "firstName",
      "type": "text",
      "required": "required"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstName", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('div', {
    staticClass: "w-input"
  }, [_c('label', {
    staticClass: "w-input__label",
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Last Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "lastName",
      "type": "text",
      "required": "required"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastName", $event.target.value)
      }
    }
  })])])]) : _vm._e(), (_vm.isProductChat) ? _c('div', [_c('div', {
    staticClass: "w-login-form__row"
  }, [_c('div', {
    staticClass: "w-input"
  }, [_c('label', {
    staticClass: "w-input__label",
    attrs: {
      "for": "chatHandle"
    }
  }, [_vm._v("Chat Handle")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.chatHandle),
      expression: "user.chatHandle"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "chatHandle",
      "type": "text",
      "required": "required"
    },
    domProps: {
      "value": (_vm.user.chatHandle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "chatHandle", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _c('div', {
    staticClass: "w-login-form__row w-login-form__row--password"
  }, [_c('password-input', {
    attrs: {
      "label": "Password",
      "autocomplete": "new-password",
      "required": "required"
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1), _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button",
    class: {
      'w-button--gray': !_vm.canSubmit, 'w-button--blue': _vm.canSubmit
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Get started")])])])]) : _vm._e(), (_vm.expired) ? _c('form', {
    staticClass: "w-login-form"
  }, [_vm._m(0), _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('router-link', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "to": {
        path: _vm.loginLink,
        query: _vm.$route.query
      },
      "tag": "button",
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Log in")])])], 1)]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("Invite code is not valid, it may have expired or has already been used.\nPlease request a new invitation or try to log in.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46d415d5","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/AcceptInvite/AcceptInvite.vue
// module id = 597
// module chunks = 1